export type RefetchPolicy = {
  enabled?: boolean
  refetchOnWindowFocus?: boolean
  refetchOnReconnect?: boolean
  refetchOnMount?: boolean
  refetchInterval?: number | false
  refetchIntervalInBackground?: boolean
  staleTime?: number
  gcTime?: number
  retry?: number | boolean
  retryDelay?: number | ((attemptIndex: number) => number)
  keepPreviousData?: boolean
}

export const DEFAULT_WAGMI_REFETCH_POLICY: RefetchPolicy = {
  enabled: true,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  refetchOnMount: true,
  refetchInterval: 30000, // 30 seconds
  refetchIntervalInBackground: false,
  staleTime: 180000, // 180 seconds
}

export const WAGMI_REFETCH_POLICY_NEVER: RefetchPolicy = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchInterval: false,
  staleTime: Infinity,
}

export const PORTFOLIO_REFETCH_POLICY: RefetchPolicy = {
  refetchOnWindowFocus: false,
  refetchInterval: false,
  staleTime: 300000, // 5 minutes
}

export const SWAP_QUOTE_REFETCH_POLICY: RefetchPolicy = {
  refetchInterval: 15000,
  retry: 0,
  gcTime: 45000,
}

export const TOKENS_BALANCES_POLICY: RefetchPolicy = {} //use defaults

export const REFETCH_POLICY_FAST: RefetchPolicy = getRefetchPolicy(4000)

export function getRefetchPolicy(refetchInterval: number): RefetchPolicy {
  return {
    refetchInterval,
    staleTime: refetchInterval * 3,
  }
}
// tanstack
export const TANSTACK_REFETCH_POLICY_FAST: RefetchPolicy = getRefetchPolicy(60 * 1000)

export const TANSTACK_REFETCH_POLICY_SLOW: RefetchPolicy = getRefetchPolicy(5 * 60 * 1000)

export function getV2PositionsRefetchPolicy(hasRecentTransactions: boolean): RefetchPolicy {
  const refetchInterval = hasRecentTransactions ? 5000 : 300000
  return getRefetchPolicy(refetchInterval)
}
